import { render, staticRenderFns } from "./CovidCheckPointQr.vue?vue&type=template&id=aa9861c4&scoped=true&"
import script from "./CovidCheckPointQr.vue?vue&type=script&lang=js&"
export * from "./CovidCheckPointQr.vue?vue&type=script&lang=js&"
import style0 from "./CovidCheckPointQr.vue?vue&type=style&index=0&id=aa9861c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9861c4",
  null
  
)

export default component.exports